class HeroParallax extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this;
    this.media = document.querySelectorAll(
      '#MainContent .shopify-section:not([id*="parallax"]), #MainContent hero-parallax-media > div',
    );
    this.buttons = this.querySelectorAll('button');
    this.container = document.getElementById('MainContent');

    this.videos = this.querySelectorAll('video') || false;
    this.toggleSoundButtons = this.querySelectorAll('button[toggleSound]') || false;

    this.bindEvents();
    this.scrolling();
  }

  bindEvents() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', (ev) => {
        const id = button.dataset.id;
        const href = button.dataset.href;

        // If the button is already active, navigate directly to the href
        if (this.getAttribute('data-active') === id) {
          window.location.href = href;

          return;
        }

        const targetElement = document.getElementById(id);
        const scrollSnap = window.scrollSnap || false;
        if (scrollSnap) {
          const targetSlide = Array.from(scrollSnap.slides).findIndex((slide) => slide.contains(targetElement));
          if (targetSlide !== -1) {
            scrollSnap.scrollToSlide(targetSlide);
          }
        } else {
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
          } else {
            console.warn(`Element with ID ${id} not found`);
          }
        }
      });
    });

    if (this.videos && this.toggleSoundButtons) {
      this.toggleSoundButtons.forEach((button) => {
        button.addEventListener('click', this.toggleSound.bind(this));
      });
    }
  }

  scrolling() {
    const observerOptions = {
      threshold: [0.5],
    };
    const observer = new IntersectionObserver(this.handleIntersection.bind(this), observerOptions);

    this.media.forEach((media) => observer.observe(media));
  }

  handleIntersection(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const id = entry.target.id;
        if (id) {
          if (id.includes('shopify-section')) {
            // history.pushState(null, null, '/');
          } else {
            // history.pushState(null, null, `#${id}`);
            this.wrapper.setAttribute('data-active', id);
          }
        }
      }
    });
  }

  toggleSound() {
    this.videos.forEach((video) => {
      if (video.muted) {
        video.muted = false;
        this.buttons.forEach((button) => {
          button.classList.remove('muted');
        });

        return;
      }

      video.muted = true;
      this.buttons.forEach((button) => {
        button.classList.add('muted');
      });
    });
  }
}

customElements.define('hero-parallax', HeroParallax);
